/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var ThirdPartyFeeDrillDownBreakDownOptions;
(function (ThirdPartyFeeDrillDownBreakDownOptions) {
    ThirdPartyFeeDrillDownBreakDownOptions["B_NAME"] = "b_name";
    ThirdPartyFeeDrillDownBreakDownOptions["VB_NAME"] = "vb_name";
    ThirdPartyFeeDrillDownBreakDownOptions["VB_PLATFORM"] = "vb_platform";
    ThirdPartyFeeDrillDownBreakDownOptions["SLUG"] = "slug";
    ThirdPartyFeeDrillDownBreakDownOptions["STORE_ID"] = "store_id";
    ThirdPartyFeeDrillDownBreakDownOptions["WHOLE"] = "whole";
    ThirdPartyFeeDrillDownBreakDownOptions["NONE"] = "none";
})(ThirdPartyFeeDrillDownBreakDownOptions || (ThirdPartyFeeDrillDownBreakDownOptions = {}));
